<template>
  <div>
    <BannerImage
      v-if="ebookData"
      :tagline="ebookData.tag"
      :heading="ebookData.title"
      :description="ebookData.desc"
      :img="{
        src: ebookData.img.src,
        width: ebookData.img.width,
        height: ebookData.img.height,
        alt: ebookData.ebookName + ' ebook front cover',
      }"
      :button-primary="buttonData"
      :segment="segment"
      :dark="dark"
      @click-primary="!directDownload ? (modalActive = true) : null"
    />

    <Modal
      class="!max-w-[480px]"
      :modal-active="modalActive"
      @close-modal="modalActive = false"
    >
      <FormEbookModal :ebook="ebookData!" :property-type="segment" />
    </Modal>
  </div>
</template>

<script setup lang="ts">
import type {
  businessEbook,
  enterpriseEbook,
  wholesaleEbook,
} from "~/utils/ebooks";
import type { Segment } from "@/types";

const props = defineProps<{
  segment: Segment;
  dark?: boolean;
  buttonLabel?: string;
  ebook: businessEbook | enterpriseEbook | wholesaleEbook;
  directDownload?: boolean;
}>();

const ebookData = computed(() => {
  if (props.segment === "business") {
    return getBusinessEbookData(props.ebook as businessEbook);
  } else if (props.segment === "enterprise") {
    return getEnterpriseEbookData(props.ebook as enterpriseEbook);
  } else if (props.segment === "wholesale") {
    return getWholesaleEbookData(props.ebook as wholesaleEbook);
  } else {
    return null;
  }
});

const buttonData = computed(() => {
  if (props.directDownload) {
    return {
      label: props.buttonLabel
        ? props.buttonLabel
        : "Get your free " + (ebookData.value?.btnTitle ?? "ebook"),
      url: ebookData.value?.ebookUrl,
      offSite: true,
    };
  } else {
    return {
      label: props.buttonLabel
        ? props.buttonLabel
        : "Get your free " + (ebookData.value?.btnTitle ?? "ebook"),
    };
  }
});

const modalActive = ref(false);
</script>
